import { FINANCIAL_STATUS } from '../../types'
import { TRebatesTableType } from './types'

export const getDisabledStatuses = (row: TRebatesTableType) => {
  const disabledStatuses = [
    FINANCIAL_STATUS.DISPUTED,
    FINANCIAL_STATUS.PAID,
    FINANCIAL_STATUS.PAYMENT_IN_PROGRESS
  ]

  return disabledStatuses.includes(row.status)
}

export const getRebatesStatusTooltip = (row: TRebatesTableType) => {
  if (
    row.status === FINANCIAL_STATUS.PARTIALLY_PAID ||
    row.status === FINANCIAL_STATUS.PAYMENT_FAILED
  ) {
    return row.transfers
      ?.filter((transfer) => transfer.status !== 'completed')
      .map((transfer) => transfer.destination.issue_label)
      .join(', ')
  }
  return ''
}
